import { render, staticRenderFns } from "./pinned-product-query-ranking-modal.vue?vue&type=template&id=cf9a1134"
import script from "./pinned-product-query-ranking-modal.vue?vue&type=script&lang=ts"
export * from "./pinned-product-query-ranking-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports